"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("PromotionRequest", [
    "$resource",
    "$stateParams",
    "apiSettings",
    function ($resource, $stateParams, apiSettings) {
      return $resource(
        apiSettings.baseUri + "v1/promotionrequests/:id",
        { id: "@id" },
        {
          list: {
            method: "GET",
            isArray: false,
            params: {
              page: 1,
              pageSize: apiSettings.defaultPageSize,
            },
          },
          listIds: {
            url: apiSettings.baseUri + "v1/promotionrequests/list/ids",
            method: "GET",
            isArray: true,
          },
          insert: {
            method: "POST",
          },
          update: {
            method: "PUT",
          },
          delete: {
            method: "DELETE",
          },
        }
      );
    },
  ]);
